import { Component, OnInit } from '@angular/core';
import { PreferencesService } from '../services/preferences.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html'
})

export class TermsComponent implements OnInit {

  sourcePath:string='../assets/terms/terms-en.md';
  languageCode: string;
  constructor(private preferencesService: PreferencesService) { }

  ngOnInit() {

    this.preferencesService.languageCode$.subscribe(code=>this.languageCode=code);
    console.log(this.languageCode);
    this.sourcePath = `./assets/terms/terms-${this.languageCode}.md`;
  }

}
